import React, { memo } from "react";
import Icon from "../../../assets/icons/Icon";

const Loading = ({ size = 30 }) => {
  return (
    <div className="spinner-box">
      <svg width={size} height="60" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="var( --gary-color)"
          strokeWidth="10"
          fill="none"
        />
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="var(--main-color)"
          strokeWidth="10"
          fill="none"
          strokeLinecap="round"
          strokeDasharray="188"
          strokeDashoffset="140"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 50 50"
            to="360 50 50"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
};

export default memo(Loading);
